import gallerya2b1 from "../dataset/galleries-a2b1.txt";
import shareIconImg from '../images/share_icon.png';
// var vConsole = new VConsole();

var galleriesMaps = {
  // 'https://exhibition.ad.tsinghua.edu.cn': gallery18df,
  // 'http://exhibition-origin.ad.onekind.com.cn': galleryd9db,
  // 'http://exhibition-staging.ad.onekind.com.cn': gallery39c6,
  'default': gallerya2b1
};

function Utils() {
  this.galleriesList = [
    {label: '87a7a032-e86f-46b0-8124-c3c95433d01b', desc: '长廊一'},
    {label: '8025fc08-3d39-4cbd-b481-788c2d15c158', desc: '长廊二'},
    {label: 'b57d4069-2a3b-428c-888f-df825857de7d', desc: '长廊三'},
    {label: 'c0bad58e-3a93-432e-99c0-c809da9c12e6', desc: '长廊四'},
    {label: '3304cf99-b8e3-44cc-a387-db697acf4da6', desc: '长廊五'},
    
    {label: '4cd5aa4f-c199-442b-8c3c-4ade19288925', desc: '长廊六'},
    {label: '33775b93-04d9-4b1e-9f68-fe9749e090e7', desc: '长廊七'},
    {label: 'e50a8d23-e51e-49b2-aa41-bf9c3a10af4a', desc: '长廊八'},

    {label: 'dee9f27a-b831-4cc9-933e-54c06d8b5da0', desc: '长廊九'},
    {label: '489946a8-2da7-4be6-8fde-29addef17a83', desc: '长廊十'},
    {label: '503c96e5-b002-419a-b6d1-818ccb467290', desc: '长廊十一'},
    
    {label: '33a3899d-43ea-48b7-90b6-1dd5c5fd3586', desc: '长廊十二'},
    {label: '4cf25291-c2d6-42b5-bd4a-a14769739a75', desc: '长廊十三'},
    {label: '32fd9dde-6c79-401d-891c-5dd490939c58', desc: '长廊十四'},
    {label: 'fdaf9506-d5e6-4a2e-8c76-755598df328d', desc: '长廊十五'},

    {label: '3a60a811-36e2-48c0-81b7-02d52cb62589', desc: '长廊十六'},
    {label: 'cfd7e6ee-8933-4705-af6f-2dd511e3fdc0', desc: '长廊十七'},
    {label: 'ab2a4a9e-3ec4-4871-97e8-966222b5a1af', desc: '长廊十八'},
  ];
};

Utils.prototype.fetchRegions = function() {
  let jsonData = galleriesMaps[window.location.origin] || galleriesMaps['default'];
  $.ajax({
    //url: 'http://exhibition-staging.ad.onekind.com.cn/galleries',
    url: jsonData,
    type: "GET",
    async: true,
    success: function(data) {
      // console.log('GET IMAGES SUCCESS!');
      // console.log(data);
      window.custom.systemList = (typeof data === 'string') ? JSON.parse(data) : data;

    }, error : function(response) {
      console.log("GET IMAGES FAILED!");
      console.log(JSON.stringify(response));
    }
  });
};

Utils.prototype.setCookie = function(name,value)
{
  var Days = 30;
  var exp = new Date();
  exp.setTime(exp.getTime() + Days*24*60*60*1000);
  // console.log(name + '..' + decodeURIComponent(value));
  document.cookie = name + "="+ escape (value) + ";expires=" + exp.toGMTString();
};

Utils.prototype.getCookie = function(name)
{
  var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");

  if(arr = document.cookie.match(reg))

    return unescape(arr[2]);
  else
    return null;
};

Utils.prototype.delCookie = function(name)
{
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = this.getCookie(name);
  if(cval != null)
    document.cookie= name + "="+cval+";expires="+exp.toGMTString();
};

Utils.prototype.isIphone = function(){
  return /iphone/gi.test(navigator.userAgent);
};

Utils.prototype.isIphoneXORIphone11Wechat = function(){
  if (typeof window !== 'undefined' && window) {
    return /iphone/gi.test(navigator.userAgent) && /micromessenger/gi.test(window.navigator.userAgent) && window.screen.height >= 812;
  }
  return false;
};

Utils.prototype.isWechat = function(){
  if (typeof window !== 'undefined' && window) {
    return /micromessenger/gi.test(window.navigator.userAgent);
  }
  return false;
};

Utils.prototype.getUrlParam = function(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
};

Utils.prototype.wechatShare = function(){
  let url = window.location.href;

  let configUrl = url.replace(/exhibition.+/,'wx.ad.onekind.com.cn/wxconfig?url=' + document.location.href);

  let sharedPicUrl = window.location.origin + '/2021/' + shareIconImg;
  let sharedPageUrl = 'https://exhibition.ad.tsinghua.edu.cn/2021/';

  // console.log(configUrl);
  // console.log(sharedPageUrl);
  // console.log(sharedPicUrl);

  $.getJSON(configUrl,function(config){
    console.log('wechat share..');
    // console.log(config);
    // alert (data.result);
    //alert(JSON.stringify(config));

    config.debug = false;
    config.jsApiList = [
      'updateTimelineShareData',
      'updateAppMessageShareData',
      'onMenuShareTimeline',
      'onMenuShareAppMessage'
    ];


    // console.log('config....');
    // console.log(JSON.stringify(config));
    window.wx = wx;
    wx.config(config);

    wx.ready(function(){
      
      wx.updateTimelineShareData && wx.updateTimelineShareData({
        title: '清华大学美术学院2021届线上毕业作品展',
        link: sharedPageUrl,
        imgUrl: sharedPicUrl,
        success: function () {
        },
        cancel: function () {
        },
        complete: function(res){
        }
      });

      wx.updateAppMessageShareData && wx.updateAppMessageShareData({
        title: '清华大学美术学院2021届线上毕业作品展',
        desc: '向多样的世界提问',
        link: sharedPageUrl,
        imgUrl: sharedPicUrl,
        success: function () {
        },
        cancel: function () {
        },
        complete: function(res){
        }
      });

      // 即将废弃
      wx.onMenuShareTimeline && wx.onMenuShareTimeline({
        title: '清华大学美术学院2021届线上毕业作品展',
        link: sharedPageUrl,
        imgUrl: sharedPicUrl,
        success: function () {
        },
        cancel: function () {
        },
        complete: function(res){
        }
      });

      // 即将废弃
      wx.onMenuShareAppMessage && wx.onMenuShareAppMessage({
        title: '清华大学美术学院2021届线上毕业作品展',
        link: sharedPageUrl,
        imgUrl: sharedPicUrl,
        desc: '向多样的世界提问',
        type: '',
        dataUrl: '',
        success: function () {
        },
        cancel: function () {
        },
        complete: function(res){
        }
      });

    });

    wx.error(function(res){
      console.log('error!!');
      console.log(res);
    });
  });
};

Utils.prototype.getVideoColor = function(video){
  var r= 0, g = 0, b = 0;
  if(video.width != undefined && video.width > 0 && video.height != undefined && video.height > 0){
      var canvas = video.snapshot().canvas;
      var context = canvas.getContext("2d");

      // 获取像素数据
      var data = context.getImageData(0, 0, canvas.width, canvas.height).data;

      // 取所有像素的平均值
      for (var row = 0; row < canvas.height; row++) {
          for (var col = 0; col < canvas.width; col++) {
              r += data[((canvas.width * row) + col) * 4];
              g += data[((canvas.width * row) + col) * 4 + 1];
              b += data[((canvas.width * row) + col) * 4 + 2];
          }
      }

      // 求取平均值
      r /= (canvas.width * canvas.height);
      g /= (canvas.width * canvas.height);
      b /= (canvas.width * canvas.height);

      // 将最终的值取整
      r = Math.round(r);
      g = Math.round(g);
      b = Math.round(b);
  }
  return {r: r, g: g, b: b};
};

Utils.prototype.timeFormate = function (timeInSeconds) {
  let result = parseInt(timeInSeconds);
  let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
  let m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
  let s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));

  let res = '';
  if(h !== '00') res += `${h}:`;
  res += `${m}:`;
  res += `${s}`;
  return res;
};

Utils.prototype.slideAimation = function(scene, direction, func) {
  let startX, targetX;
  let duration = GC.animationDuration;
  if(direction == 'in') {
    startX = scene.scaler.scaleX(scene.scaler.designRefWidth());
    targetX = 0;
  }
  if(direction == 'out') {
    startX = 0;
    targetX = -scene.scaler.scaleX(scene.scaler.designRefWidth());
  }
  if(direction == 'back') {
    startX = 0;
    targetX = scene.scaler.scaleX(scene.scaler.designRefWidth());
  }
  if(direction == 'leftIn') {
    startX = -scene.scaler.scaleX(scene.scaler.designRefWidth());
    targetX = 0;
  }
  

  // var ease = 'Linear';
  var ease = 'Sine.easeInOut';
  if(scene.scaler.getDirection() == 'Horizontal') {
    scene.tweens.add({
      targets: scene.cameras.main,
      x: {
        start: startX,
        to: targetX
      },
      duration: duration,
      delay: 0,
      ease: ease,
      repeat: 0,
      yoyo: false,
      onComplete: function () {
        if(func) {
          func();
        }
      },
    }); 
  } else {
    scene.tweens.add({
      targets: scene.cameras.main,
      y: {
        start: startX,
        to: targetX
      },
      duration: duration,
      delay: 0,
      ease: ease,
      repeat: 0,
      yoyo: false,
      onComplete: function () {
        if(func) {
          func();
        }
      },
    }); 
  }
  
};

Utils.prototype.updateButtonsAlpha = function(scene) {
  var phaserElements = scene.children.list;
  phaserElements.forEach(sprite => {
    if(sprite.keepData && sprite.keepData.enableClick) {
      sprite.alpha = sprite.keepData.alpha;
      sprite.isPressed =  false;
    }
  });
};

Utils.prototype.enableAllButtons = function(scene) {
  var phaserElements = scene.children.list;
  phaserElements.forEach(sprite => {
    if(sprite.keepData.enableClick) {
      sprite.setInteractive();
    }
  });
};

Utils.prototype.disableAllButtons = function(scene) {
  var phaserElements = scene.children.list;
  phaserElements.forEach(sprite => {
    if(sprite.keepData.enableClick) {
      sprite.disableInteractive();
    }
  });
};

export default Utils;